module.exports = __webpack_public_path__ + "img/Image.5459e4c3.png";